import { appApi } from "@/api";
import { env } from "@/config/env";
import type { CouponPackagePopup } from "@/types/api";
import { auth } from "./auth";
import { storage, storageKeys } from "./storage";

let bootstrapPromise: Promise<void> | null = null;
export const COUPON_PACKAGE_POPUP_EVENT = "athome:coupon-package-popup";

const resolveToken = (payload: {
  token?: string;
  accessToken?: string;
  userId?: number;
  user_id?: number;
  nickname?: string;
  avatar?: string;
  mobile?: string;
  user_info?: {
    id?: number;
    nickname?: string;
    avatar?: string;
    mobile?: string;
  };
  pending_coupon_package_popup?: CouponPackagePopup | null;
}) => {
  const token = payload.token || payload.accessToken || "";
  const userInfo = payload.user_info || {
    id: payload.userId || payload.user_id,
    nickname: payload.nickname,
    avatar: payload.avatar,
    mobile: payload.mobile,
  };

  if (token) {
    auth.setToken(token);
  }

  if (userInfo.id || userInfo.nickname || userInfo.mobile || userInfo.avatar) {
    auth.setUserInfo(userInfo);
  }

  const popup = payload.pending_coupon_package_popup;
  if (popup?.record_id) {
    storage.set(storageKeys.couponPackagePopup, popup);
    window.dispatchEvent(new CustomEvent(COUPON_PACKAGE_POPUP_EVENT, { detail: popup }));
  }
};

const canUseDebugLogin = () => Boolean(env.debugLoginMobile && env.debugLoginCaptcha);

export const session = {
  async bootstrap() {
    if (auth.getToken()) {
      return;
    }

    if (!env.isDev || !canUseDebugLogin()) {
      return;
    }

    if (!bootstrapPromise) {
      bootstrapPromise = appApi
        .loginAccount({
          mobile: env.debugLoginMobile,
          captcha: env.debugLoginCaptcha,
          terminal: env.debugLoginTerminal,
        })
        .then((payload) => {
          storage.remove(storageKeys.city);
          resolveToken(payload);
        })
        .finally(() => {
          bootstrapPromise = null;
        });
    }

    return bootstrapPromise;
  },

  saveLogin(payload: Parameters<typeof resolveToken>[0]) {
    storage.remove(storageKeys.city);
    resolveToken(payload);
  },
};
